import React from 'react';

interface Props {
  data: {
    firstName: string;
    lastName: string;
    role: string;
    email: string;
  };
  updateData: (data: Partial<typeof Props['data']>) => void;
}

export const UserDetails = ({ data, updateData }: Props) => {
  const roles = ['CEO', 'HR Manager', 'Team Lead', 'Other'];

  return (
    <div>
      <h2 className="text-2xl font-semibold text-center text-gray-900 mb-6">
        Who's setting this up?
      </h2>

      <div className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              First Name
            </label>
            <input
              type="text"
              value={data.firstName}
              onChange={(e) => updateData({ firstName: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4B6BFB] focus:border-transparent"
              placeholder="Enter first name"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Last Name
            </label>
            <input
              type="text"
              value={data.lastName}
              onChange={(e) => updateData({ lastName: e.target.value })}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4B6BFB] focus:border-transparent"
              placeholder="Enter last name"
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Role
          </label>
          <select
            value={data.role}
            onChange={(e) => updateData({ role: e.target.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#4B6BFB] focus:border-transparent"
          >
            <option value="">Select role</option>
            {roles.map((role) => (
              <option key={role} value={role}>
                {role}
              </option>
            ))}
          </select>
          <p className="mt-2 text-sm text-gray-500">
            This helps us personalize your dashboard.
          </p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Email
          </label>
          <input
            type="email"
            value={data.email}
            disabled
            className="w-full px-4 py-2 bg-gray-50 border border-gray-300 rounded-lg text-gray-700"
          />
        </div>
      </div>
    </div>
  );
};